/** Company profile the customer fills in once (stored by the owner, namespaced for the Nave). */
export const EMPLOYEE_RANGES = ["1", "2-10", "11-50", "51-200", "201-500", "500+"] as const;
export type EmployeeRange = (typeof EMPLOYEE_RANGES)[number];

export type CompanyProfile = Readonly<{
  employeesRange?: EmployeeRange;
  segment?: string;
  website?: string;
  description?: string;
}>;

export type CompanyProfileState = Readonly<{ profile: CompanyProfile; complete: boolean; canEdit: boolean }>;

export type CompanyProfileInput = Readonly<{ employeesRange: EmployeeRange; segment: string; website?: string; description?: string }>;

const record = (value: unknown): value is Record<string, unknown> => typeof value === "object" && value !== null && !Array.isArray(value);
const bounded = (value: unknown, max: number): string | undefined => typeof value === "string" && value !== "" && value.length <= max ? value : undefined;

/** Allow-list projection: unknown owner fields are dropped, malformed payloads are rejected. */
export const companyProfileProjection = (input: unknown): CompanyProfileState | undefined => {
  if (!record(input) || !record(input.profile) || typeof input.complete !== "boolean" || typeof input.canEdit !== "boolean") return undefined;
  const source = input.profile;
  const employeesRange = EMPLOYEE_RANGES.find((range) => range === source.employeesRange);
  const segment = bounded(source.segment, 120), website = bounded(source.website, 200), description = bounded(source.description, 600);
  return {
    profile: { ...(employeesRange ? { employeesRange } : {}), ...(segment ? { segment } : {}), ...(website ? { website } : {}), ...(description ? { description } : {}) },
    complete: input.complete, canEdit: input.canEdit,
  };
};
